import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { navigateToHome } from '../lib/navigation';
import BrandLogo from './BrandLogo';

const AppTopHeader = ({
  title,
  subtitle,
  backLabel = 'Back',
  onBack,
  backToHome = false,
  hideBackButton = false,
  rightSlot = null,
  sticky = false,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    if (backToHome) {
      navigateToHome(navigate);
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigateToHome(navigate);
  };

  return (
    <header className={`${sticky ? 'sticky top-0 z-50 ' : ''}w-full bg-white border-b border-slate-200`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-1 min-w-0">
            {!hideBackButton && (
              <button
                onClick={handleBack}
                className="inline-flex items-center justify-center w-9 h-9 rounded-lg text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition"
                aria-label={backLabel}
                title={backLabel}
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
            )}
            <div className="flex items-center gap-2 min-w-0">
              <BrandLogo className="h-10 w-auto shrink-0" />
              {(title || subtitle) && (
                <p className="text-xs text-slate-500 truncate">{title || subtitle}</p>
              )}
            </div>
          </div>
          {rightSlot && <div className="shrink-0">{rightSlot}</div>}
        </div>
      </div>
    </header>
  );
};

export default AppTopHeader;
